import React, {Component} from 'react';
import { combineReducers, createStore } from 'redux';
import { Provider } from 'react-redux';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory } from 'react-router';

import store from '../store/reducers';
import * as meta from '../store/constants/meta_info';

import Contact from './Contact';
import Home from './Home';
import Home2 from './Home2';
import Privacy from './Privacy';
import Terms from './Terms';
import AppContainer from './appContainer';
import NotFound from './notFound';
import Store from './Store';
import PressKit from './PressKit';
import Links from './Links';

import ReactGA from 'react-ga';
ReactGA.initialize(meta.ga_tracking_code);

function fireTracking() {
  if (!meta.isDevelopmentMode) {
    ReactGA.pageview(window.location.pathname);
  }
}

export default class Routes extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Provider store={store}>
        <Router history={browserHistory} onUpdate={fireTracking}>
          <Route path='/' component={AppContainer} meta={meta}>
            <IndexRoute component={Home2} meta={meta} />
            <Route path='privacy' component={Privacy} meta={meta} />
            <Route path='terms' component={Terms} meta={meta} />
            <Route path='contact' component={Contact} meta={meta} />
            <Route path='links' component={Links} meta={meta} />
            <Route path='store' component={Store} meta={meta} />
            <Route path='presskit' component={PressKit} meta={meta} />
            <Route path='*' component={NotFound} meta={meta} />
          </Route>
        </Router>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/router.js